interface PreviewLinkTask {
    id: string;
    title: string;
    blockedByTaskIds: readonly string[];
    relatedTaskIds: readonly string[];
}

interface ResolvedPreviewLinks {
    blockedBy: string;
    relatedTo: string;
}

const joinTitles = (
    ids: readonly string[],
    titleById: ReadonlyMap<string, string>,
): string =>
    ids
        .flatMap((id) => {
            const title = titleById.get(id);
            return title === undefined ? [] : [title];
        })
        .join(", ");

export function resolvePreviewTaskLinks(
    visibleTasks: readonly PreviewLinkTask[],
): Map<string, ResolvedPreviewLinks> {
    const titleById = new Map(visibleTasks.map((t) => [t.id, t.title]));
    return new Map(
        visibleTasks.map((task) => [
            task.id,
            {
                blockedBy: joinTitles(task.blockedByTaskIds, titleById),
                relatedTo: joinTitles(task.relatedTaskIds, titleById),
            },
        ]),
    );
}
